import barba from "@barba/core";

(function ($) {
	const initSmoothScroll = () => {
		$("a[href*='#']").click((e) => {
            let hash = e.currentTarget.href.split("#");

            if (hash[1] !== "") {
                const elToScroll = document.querySelector("#" + hash[1]);
                if (!!elToScroll) {
                    e.preventDefault();

                    if (navigator.userAgent.includes("Firefox")) {
                        window.scrollTo({
                            top: elToScroll.offsetTop - jQuery('.header').outerHeight(),
                        });
                    } else {
                        window.scrollTo({
                            top: elToScroll.offsetTop - jQuery('.header').outerHeight(),
                            behavior: "smooth",
                        });
                    }

                }
            }
		});
	};

    const initPreload = () => {
        if (window.location.hash) {
            let hash;
            hash = window.location.hash.split("#");

            if (hash[1] !== "") {
                const elToScroll = document.querySelector("#" + hash[1]);
                if (!!elToScroll) {
                    if (navigator.userAgent.includes("Firefox")) {
                        window.scrollTo({
                            top: elToScroll.offsetTop - document.querySelector('.header').offsetHeight,
                        });
                    } else {
                        window.scrollTo({
                            top: elToScroll.offsetTop - document.querySelector('.header').offsetHeight,
                            behavior: "smooth",
                        });
                    }

                }
            }
        }
    };

    setTimeout(function() {
        initPreload();
    }, 1000);

	barba.hooks.beforeEnter(initSmoothScroll);
	document.addEventListener("DOMContentLoaded", initSmoothScroll);
})(window.jQuery);
